import { Injectable } from '@angular/core';
import { fromJS, Map } from 'immutable';
import { Document } from '../../../document-data/document.model';
import { Deposit } from '../../../document-data/sub-models/deposit.model';

@Injectable()
export class DocumentPaymentActionsBuilder {
  constructor() {}

  buildDocumentContentPropsFromDeposit(deposit: Deposit): Map<string, any> {
    return fromJS({ [Document.CONTENT_KEYS.DEPOSIT]: deposit });
  }
}
